import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { FiArrowUpRight, FiUser, FiCalendar, FiHome, FiChevronRight } from "react-icons/fi";
import { BLOG_POSTS } from "../data/blogData";
import blogHeroImg from "../assets/Blog post-amico.png";

const stagger = {
  hidden: { opacity: 0 },
  show: { opacity: 1, transition: { staggerChildren: 0.08 } },
};

const cardAnim = {
  hidden: { opacity: 0, y: 24 },
  show: { opacity: 1, y: 0, transition: { duration: 0.5, ease: [0.22, 1, 0.36, 1] } },
};

function BlogPage() {
  return (
    <main className="blog-page">
      {/* HERO — split layout with image */}
      <section className="blog-hero-section">
        <div className="blog-hero-inner">
          <motion.div
            className="blog-hero-content"
            initial={{ opacity: 0, x: -40 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7 }}
          >
            <span className="svc-hero-badge">Our Blog</span>
            <h1>Insights &amp; Strategies for Digital Growth</h1>
            <p>Tips, guides, and expert insights to help your business grow online through SEO, PPC, social media, and more.</p>
            <nav className="blog-hero-breadcrumb" aria-label="breadcrumb">
              <Link to="/"><FiHome /> Home</Link>
              <FiChevronRight />
              <span>Our Blog</span>
            </nav>
          </motion.div>
          <motion.div
            className="blog-hero-img-wrap"
            initial={{ opacity: 0, x: 40 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7, delay: 0.15 }}
          >
            <img src={blogHeroImg} alt="Blog" />
          </motion.div>
        </div>
      </section>

      {/* BLOG GRID */}
      <section className="blog-listing-section blog-listing-section--clean">
        <div className="container-custom">
          <motion.div
            className="blog-listing-grid blog-listing-grid--full"
            variants={stagger}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.05 }}
          >
            {BLOG_POSTS.map((post) => (
              <motion.article key={post.id} className="blog-listing-card" variants={cardAnim}>
                <Link to={`/blog/${post.id}`} className="blog-listing-img-wrap">
                  <img src={post.image} alt={post.title} />
                  <span className="blog-listing-cat">{post.category}</span>
                </Link>
                <div className="blog-listing-body">
                  <div className="blog-listing-meta">
                    <span><FiUser /> {post.author}</span>
                    <span><FiCalendar /> {post.date}</span>
                  </div>
                  <h3><Link to={`/blog/${post.id}`}>{post.title}</Link></h3>
                  <p>{post.excerpt}</p>
                  <Link to={`/blog/${post.id}`} className="blog-read-more">
                    Read More <FiArrowUpRight />
                  </Link>
                </div>
              </motion.article>
            ))}
          </motion.div>
        </div>
      </section>
    </main>
  );
}

export default BlogPage;
